import axios from "axios";
import store from "@/store/index.js";
import {BaseUrl} from "@/utils/config";
import {ElMessage} from "element-plus";
import router from "@/router";
import {loadings, message} from '@/utils/common';

const pendingSubmits = new Set();

// 创建 Axios 实例并设置全局拦截器
const axiosInstance = axios.create({
    baseURL: BaseUrl,
});

axiosInstance.interceptors.request.use(
    config => {
        config.headers['Authorization'] = store.getters['basic/get_token'] ?? '';
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

const http = ({ url, data, tip = false, files = false, loading = false, responseType = '', method = 'post' }) => {

    if (tip && pendingSubmits.has(url)) {
        message.alert('请求正在处理，请勿重复点击');
        return Promise.resolve({ code: -1, msg: '重复提交已拦截', data: '' });
    }

    if (tip) {
        pendingSubmits.add(url);
    }

    if (loading) {
        loadings.show();
    }

    return new Promise((resolve, reject) => {
        const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;
        const headers = isFormData || files
            ? {}
            : {
                "Content-Type": "application/json",
            };

        axiosInstance.request({
            url,
            method,
            ...(method.toLowerCase() === 'get' ? { params: data } : { data }),
            headers,
            ...(responseType ? { responseType } : {}),
        })
            .then(res => {
                if (tip) {
                    pendingSubmits.delete(url);
                }

                if (responseType) {
                    if (loading) loadings.hide();
                    resolve({ data: res.data, headers: res.headers, status: res.status });
                    return;
                }

                if (res.data.code === 10001) {
                    router.push({ path: '/login' }).then(r => r);
                }

                if (tip) {
                    if (res.data.code === 0) {
                        ElMessage({
                            message: res.data.msg,
                            type: 'success',
                        });
                    } else {
                        message.fail(res.data.msg || '操作失败');
                    }
                }
                if (loading) {
                    loadings.hide();
                }
                resolve(res.data);
            })
            .catch(error => {
                console.error("HTTP request failed:", error);

                if (tip) {
                    pendingSubmits.delete(url);
                }
                if (loading) {
                    loadings.hide();
                }
                if (tip) {
                    message.fail(error?.message || '网络连接失败，请稍后重试');
                }
                reject(error);
            });
    })
}

export default http;
